// extracted by mini-css-extract-plugin
module.exports = {"PurchaseTextInput":"PurchaseTextInput_PurchaseTextInput__3aOin","isSetValue":"PurchaseTextInput_isSetValue__1758o"};